import { InfoOutlineIcon } from "@chakra-ui/icons";
import { Box, Flex, Text, Tooltip } from "@chakra-ui/react";

import { useColor } from "@/styles/useColor";

interface PriceImpactDisplayProps {
  priceImpact: number;
}

export const PriceImpactDisplay = ({ priceImpact }: PriceImpactDisplayProps) => {
  const color = useColor();

  return (
    <Flex alignItems="center" justifyContent="space-between">
      <Flex alignItems="center" gap="2">
        <Text color={color("500")} fontWeight="600">
          Price Impact
        </Text>
        <Tooltip label="How your trade influences the market price in this pool.">
          <Box as="span">
            <InfoOutlineIcon width="16px" height="16px" color={color("500")} />
          </Box>
        </Tooltip>
      </Flex>
      <Text color={color("700")}>{priceImpact.toFixed(2)}%</Text>
    </Flex>
  );
};
